export const TRACKING_PERFORMANCE_PAGES = {
  ISSUES_LOG: "Issues log",
  TYPES: "Types",
  CUSTOM_FIELDS: "Custom fields",
  PERMISSIONS: "Permissions",
  ROOT_CAUSES: "Root causes",
  TEMPLATES: "Templates",
  STATUSES: "Statuses",
};

export const TRACKING_PERFORMANCE_COMPONENTS = {
  TABLE: "Table",
};
